import qs from 'query-string';

export function getQuery(state) {
  return qs.stringify(state.listings.query);
}


// WEBPACK FOOTER //
// ./src/listing/listing.selectors.js